import React from "react";
import { QuestionCircleOutlined, LogoutOutlined } from "@ant-design/icons";
import { Menu, Space, Dropdown, Avatar } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { logoutRequest } from "../../feature/auth/authSlice";
import { authSelector } from "../../feature/auth/authSelector";

const user = {
  avatar: "https://gw.alipayobjects.com/zos/rmsportal/BiazfanxmamNRoxxVxka.png",
};

const menu = (callback) => (
  <Menu className="user-menu-dropdown">
    <Menu.Item key="logout" onClick={() => callback()}>
      <LogoutOutlined />
      <span className="ml-5">Logout</span>
    </Menu.Item>
  </Menu>
);

const Header = () => {
  const { userState } = useSelector(({ authState }) => authSelector(authState));
  const dispatch = useDispatch();

  const onLogout = () => {
    dispatch(logoutRequest());
  };

  const renderName = () => {
    return `${userState.firstName || ""} ${userState.lastName || ""}`;
  };

  return (
    <div className="header-container">
      <Space>
        <QuestionCircleOutlined />
        <Dropdown overlay={menu(onLogout)} placement="bottomRight">
          <div className="user">
            <Avatar size="small" src={user.avatar} alt="avatar" />
            <span className="ml-5">{renderName()}</span>
          </div>
        </Dropdown>
      </Space>
    </div>
  );
};

export default Header;
